export default "__VITE_ASSET__D1wOqPn9__"